import React, { useEffect, useRef, useState } from 'react';

interface IProps {
  children: React.ReactNode;
  toolTipChildren?: React.ReactNode;
  conditionalAppearance?: boolean;
  tooltipClassName?: string;
  childrenClassName?: string;
}

export const LiliToolTip = ({
  children,
  toolTipChildren,
  conditionalAppearance,
  tooltipClassName,
  childrenClassName,
}: IProps) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const elChildrenTrigger = useRef<HTMLDivElement>(null);

  const handleMouseEnter = (e: any, mode: boolean) => {
    if (!mode) {
      setIsActive(false);
    }
    if (!conditionalAppearance) {
      setIsActive(mode);
    } else if (e.target.offsetWidth < e.target.scrollWidth) {
      setIsActive(mode);
    }
  };

  useEffect(() => {
    if (!elChildrenTrigger.current) return;
    const elFirstChild = elChildrenTrigger?.current?.firstElementChild;
    if (!elFirstChild) return;

    elFirstChild.addEventListener('mouseenter', (e: any) => {
      handleMouseEnter(e, true);
    });

    elFirstChild.addEventListener('mouseleave', (e: any) => {
      handleMouseEnter(e, false);
    });

    // eslint-disable-next-line
    return () => {
      elFirstChild.removeEventListener('mouseenter', () => {});
      elFirstChild.removeEventListener('mouseleave', () => {});
    };
  }, [elChildrenTrigger.current]);

  return (
    <div className={tooltipClassName || 'relative w-full'}>
      {isActive && toolTipChildren && (
        <div
          className={
            childrenClassName ||
            `fadeIn before:w-[10px] before:h-[10px] before:bg-bw00 before:border-bw04 before:border-b before:border-r before:absolute
        before:left-[50%] before:translate-x-[-50%] before:rotate-[45deg] before:translate-y-[55%] before:bottom-0 absolute z-[9999] top-0 left-[50%] translate-x-[-50%]
        translate-y-[calc(-100%-10px)] bg-bw00 border border-bw04 px-[12px] py-[6px] rounded-[6px] shadow-light flex items-center justify-center w-fit max-w-[100%]`
          }
        >
          {toolTipChildren}
        </div>
      )}
      <div className='flex items-center justify-center' ref={elChildrenTrigger}>
        {children}
      </div>
    </div>
  );
};
